export enum Modules {
    //This first section is on the user level
    PolicyAdmin = "PolicyAdmin",
    BDXPortal = "BDXPortal",
    SafetyNow = "SafetyNow",
    ProfileSwitch = "Admin.SwitchProfile",
    AdminUtil = "Admin.Utility",
    //This section are all on the company level
    AccountList = "Account.List",
	AccountSearch = "Account.Search",
	AccountPolicies = "Account.Policies",
	AccountDocs = "Account.Docs",
	AccountClaims = "Account.Claims",
	AccountBillDirect = "Account.Bill.Direct",
	AccountEndtView = "Account.Endt.View",
	ClaimList = "Claim.List",
	ClaimSearch = "Claim.Search",
	ClaimDetails = "Claim.Details",
	ClaimFinancials = "Claim.Financials",
	ClaimAdj = "Claim.Adj",
	ClaimNotes = "Claim.Notes",
	NBSubmission = "NB.Submission",
	NBDICE = "NB.DICE",
	NBDNBLookup = "NB.DNB.Lookup",
	PolicyList = "Policy.List",
	PolicySearch = "Policy.Search",
	PolicyDetails = "Policy.Details",
	PolicyFinancials = "Policy.Financials",
	PolicyDocs = "Policy.Docs",
	PolicyClaims = "Policy.Claims",
	PolicyEndtView = "Policy.Endt.View",
	PolicyEndtSubmit = "Policy.Endt.Submit",
	ReportLRAccount = "Report.LR.Account",
	ReportLRPolicy = "Report.LR.Policy",
	ReportClaimAck = "Report.Claim.Ack",
	ReportBillingPCN = "Report.Billing.PCN",
	Renewals = "Renewals",
	LossControl = "LossControl",
	QuickAccess = "QuickAccess",
    BORSkip = "BOR.Skip",
}

export enum StatusCode{
    NoAccess = "405",
    InternalServer = "500",
    Success = "200",
    BadData = "400",
    AuthenticationFailed = "401",
    Polling = "202"
}
export enum UserType{
    ProSight = "ProSight",
    Vendor = "Vendor",
    Agent = "Agent"
}

export enum EditorOptionTypeEnum{
    INTEGER = "number",
    BOOLEAN = "boolean",
    STRING = "string",
    DATE = "date"
}

/* Below enum is for detecting user status while activation */
export enum CustomUserStatus{
    Active = "Active",
    Deactivated = "Deactivated",
    PendingActivation = "Pending Activation",
    Expired = "Expired",
    NotFound = "NotFound",
    InvalidUser = "InvalidUser"
}
/* Below enum is for detecting user status while activation */
export enum UserStatusID{
    Active = "1",
    Deactivated = "2",
    OnHold = "3",
    PendingActivation = "4",
    Expired = "5",
    Reset = "6"
}

export enum UserRole{
    SuperAdmin = "Super Admin",
    SiteAdmin = "Site Admin",
    SiteContributor = "Site Contributor",
    CompanyAdmin = "Company Admin",
    SuperUser = "Super User",
    User = "User"
}

export enum CompanyType{
    Agent = "Agent",
    Prosight = "ProSight",
    Vendor = "Vendor",
    TPA = "TPA"
}
/* Below enum is for detecting company status while activation */
export enum CompanyStatusID{
    Active = "1",
    Deactivated = "2"
}

export enum AddressType {
    Business = 'Business',
    Mailing = 'Mailing',
    Billing = "Billing",
    Secondary = 'Secondary'
}

export enum AddressVerified {
    Verified = 'Verified',
    Overridden = 'Overridden'
}

/* Dice Level Enum */
export enum AccountStatus {
    Available = "Available",
    Referred = 'Referred to Underwriting',
    NotAvailable = "Not Available",
    Issued = "Issued"
}

export enum QuoteStatus {
    Referred = "Referred to Underwriting",
    Expired = "Expired",
    Blocked = "Blocked",
    Quoted = "Quoted",
    Issued = "Issued",
    Bound = "Bound",
    NotTaken = "Not Taken",
    New = "New"
}

export enum LobStatus {
    Referred = "Referred to Underwriting",
    Offline = "Offline Processing",
    Expired = "Expired",
    Blocked = "Blocked",
    Quoted = "Quoted",
    Issued = "Issued",
    New = "New"
}

export enum DiceSteps {
    BasicInfo = 'Basic Info',
    Application = 'Application',
    Coverages = 'Coverage',
    Review = 'Review'
}

export enum DiceFormStatus {
    Started = 'Started',
    NotStarted = 'Not Started',
    Completed = 'Completed',
    Locked = 'Locked'
}

export enum WCpayroll {
    IfAny = 'If Any',
    Amount = 'Amount'
}

export enum DiceQuoteTypes {
    Copy = 'Copy',
    New = 'New'
}

// being used in bind-nissue component and in renewal bindnissue component
export enum DefaultPaymentPlan{
    DefaultPlan = 'Annual'
}

export enum HiredorBorrowedPD {
    HiredorBorrowedPDConst = 'HiredorBorrowedPD'
}

export enum WOS{
    GLBlanketWaiverofSubrogation = 'BlanketWaiverofSubrogation',
    GLSpecificWaiverofSubrogation = 'SpecificWaiverofSubrogation',
    AUWaiverofSubAddIns = 'WaiverofSubAddIns'
}

/* Endorsement Level Enum */
export enum EndorsementSteps {
    BasicInfo = "Basic Info",
    UnderwritingNeeds = "Underwriting Needs",
    Review = "Review",
    Success = "Success"
}

export enum LobCodes{
    GL = 'GL',
    IM = 'IM',
    IMNY = 'IM-NY',
    AU = 'AU',
    AUMA = 'AU-MA',
    WC = 'WC',
    UMB = 'UMB'
}

export enum LOBType{
    Account = "ACCOUNT",
    Other = "OTHER",
    Automobile = "AU",
    BOP = "BOP",
    Crime = "CR",
    Excess = "EX",
    GeneralLiability = "GL",
    InlandMarine = "IM",
    Package = "Package",
    ProfessionalLiability = "PL",
    Property = "PR",
    Umbrella = "UM",
    WorkersCompensation = "WC",
    Excess_Umbrella = "EX_UM",
    Common = "COMMON"
}

export enum LOBTypeFullName {
    Package = "Package",
    GeneralLiability = "GeneralLiability",
    InlandMarine = "Inland Marine",
    ProfessionalLiability = "ProfessionalLiability",
    Property = "Property",
    Umbrella = "Umbrella",
    WorkersCompensation = "WorkersCompensation",
    Crime = "Crime",
    Excess = "Excess",
    Automobile = "CommercialAuto",
    AutomobileMA = "CommercialAutoMA"
}

export enum LOBTypeDisplayName {
    GL = "General Liability",
    IM = "DICE Portfolio",
    AU = "Business Auto",
    WC = "Workers' Compensation",
    UMB = "Umbrella & Excess Liability"
}

export enum EndorsementType{
    MailingAddress = "MAILINGADDRESS",
    NamedInsured = "NAMEDINSURED",
    Other = "OTHER",

    AdditionalInterest = "ADDITIONALINTEREST",
    Location = "LOCATION",

    VehicleExposureAndCoverages = "VEHICLEEXPOSUREANDCOVERAGES",
    MonthlyReporter = "MONTHLYREPORTER",
    GaragingLocation = "GARAGINGLOCATION",
    DriverReview = "DRIVERREVIEW",
    
    Coverages = "COVERAGES",

    ClassExposure = "CLASSEXPOSURE",
    ClassExposureAndCoverages = "CLASSEXPOSUREANDCOVERAGES",

    CoveragesAndLimits = "COVERAGESANDLIMITS",

    BuildingAndLocation = "BUILDINGANDLOCATION",

    RetainedLimitsAndUnderliers = "RETAINEDLIMITSANDUNDERLIERS",

    EntityAndLocation = "ENTITYANDLOCATION"
}

export enum ClassAction{
    ADD = "Add",
    UPDATE = "Update",
    DELETE = "Delete"
}

export enum LocationType{
    NEW = "New Location",
    EXISTING = "Existing Location",
    PRIMARY = "Primary Location",

    PRIMARY_LABEL = "Primary",
    BUSINESS_LABEL = "Business",
    MAILING_LABEL = "Mailing",
    BILLING_LABEL = "Billing",

    MAILING_ADDRESS = "Mailing Address",
    BILLING_ADDRESS = "Billing Address",
}

/* Endorsement Level Enum */


export enum DocumentFileType {
    Acord = "Acord",
    MonthlyReporter = "MonthlyReporter",
    DriverReview = "DriverReview",
    InsuranceApplication = "InsuranceApplication",                      /** SUBMISSION */
    SupplementalApplication = "SupplementalApplication",                /** SUBMISSION */
    PriorLossRuns = "PriorLossRuns",                                    /** SUBMISSION */
    Resume = "Resume",                                                  /** DICE & SUBMISSION */
    Financials = "Financials",                                          /** SUBMISSION */
    ContractsAgreements = "ContractsAgreements",                        /** SUBMISSION */
    MVR = "MVR",                                                        /** SUBMISSION */
    Other = "Other",                                                    /** SUBMISSION & RENEWALS */

    TriaWaiver = "TRIA Waiver",                                         /** DICE **/
    OfficerWaivers = "Officer Waivers",                                 /** DICE **/
    UMUIMForm = "UM UIM Coverage Form",                                 /** DICE **/
    COI = "COI",                                                        /** DICE **/

    IncludedExcludedOfficers = "WC Included Excluded Officers",         /** Renewals **/

    NOC = "Carrier Cancellation Notice",                                /** Policy Docs **/
    Rescission = "Rescission Notice"                                    /** Policy Docs **/
}

/* Submissions Level Enum */
export enum SubmissionSteps {
    BasicInfo = "Basic Info",
    Coverage = "Coverage",
    Attachments = "Attachments",
    Review = "Review",
    Success = "Success",
    
    SubmissionDetails = "Submission Details"
}

/* Submissions Level Enum */
export enum SubmissionDetails {
    SubmissionDetails = "Submission Details",
    AttachmentDetails = "Attachments"
}

/* Submissions Level Enum */
export enum PSIOperators {
    AND = "AND",
    OR = "OR"
}

export enum NewBusiness{
    SUBMISSIONS = "Submissions",
    DICE = "DICE Quotes"
}

export enum MaxCalendarDate {
    Dice = 60
}

/**** Below BillingType is used for 
    * Dice - BindNIssue screen and on 
    * Direct Bill - Account Activity screen
****/
export enum BillingType {
    Direct = 'Direct',
    MonthlyReporter = 'MonthlyReporter',
    Agency = 'Agency'
}

export enum ContactRoleType {
    Audit = 'Audit',
    Billing = 'Billing'
}

export enum VerifyAddressTypes{
    VERIFIED = "Verified",
    OVERRIDDEN = "Overridden",
    DNBVERIFIED = "DNBVerified"
}

export enum ClearAccountIndicators{
    BLOCKED = 0,
    NEW = 1,
    DUPLICATEERROR = 2,
    DUPLICATE = 3,
    REFERETOUW = 4
}

export enum CoverageStatus{
    InReview = "In Review",
    Reserved = "Reserved",
    DeclinedByUW = "Declined By UW",
    DeclinedByAgent = "Declined By Agent",
    Unknown = "Unknown",
    Closed = "Closed",
    Block = "Block"
}

export enum Channel{
    Submission = "Submission",
    DICE = "Dice"
}

export enum ReportingPeriodDescription {
    InitialDeposit = "Initial Deposit",
    Audit = "Final Audit",
    BillingFees = "Billing Fees"
}

export enum ReportDetailType {
    MonthlyExposure = "MonthlyExposure",
    NetRate = "NetRate"
}

export enum PolicyType{
    AUTOMOBILE = "Automobile",
    WORKERS_COMP = "Workers Compensation"
}

export enum VehicleTypes{
    VEHICLE = "vehicle",
    VEHICLE_UNIT_COUNT = "vehicle unit count",
    MILEAGE = "mileage",
    VEHICLE_STATED_VALUE = "vehicle stated value",
    TIV = "tiv"
}

export enum DandBEventsTypes {
    Typeahead = "typeahead",
    Choice = "choice",
    ChoiceSubmitted = "choicesubmitted",
    BackToSearch = "backtosearch"
}

export enum ThirdPartyNames {
    DNB = "DNB"
}

export enum CustomInputType {
    AMOUNT = "amount",
    NUMBER = "number",
    PHONE = "phone"
}

export enum FactorTypes {
    text = "sms",
    email = "email",
    push = "push",
    totp = "token:software:totp"
}

export enum MfaStatus {
    active = "ACTIVE",
    pending = "PENDING_ACTIVATION",
    enrolling = "MFA_ENROLL_ACTIVATE"
}

/* Renewal Enum */
export enum RenewalType{
    START = "start",
    CHANGE = "changerequest",
    BIND = "bind"
}
export enum RenewalStatus{
    NON_RENEWED = "non-renewed",
    RENEWAL_PERIOD_OPEN = "renewal period open",
    RENEWAL_IN_PROGRESS = "renewal in progress",
    OFFLINE_PROCESSING = "offline processing",
    RENEWAL_BOUND = "renewal bound",
    RENEWAL_ISSUED = "renewal issued",
    RENEWAL_DECLINED = "renewal declined",
    RENEWAL_PERIOD_EXPIRED = "renewal period expired",
    REFERRED_TO_UNDERWRITING = "referred to underwriting",
    BLOCKED = "blocked",
    AVAILABLE = "posted"
}

export enum RenewalSteps{
    BasicInfo = "Basic Info",
    Review = "Review",
    Success = "Success",
    Decline = "Decline",
    
    SubmissionDetails = "Submission Details"
}

export enum RenewalPolicyOptions {
    YES = "Yes, renew",
    NO = "Do not renew"
}
export enum RenewalCoverageAcceptOptionsValue {
    ACCEPT = "Accepted",
    DECLINE = "Declined",
    UPLOAD = "Upload a waiver",
    SKIP = "Skipped Step, waiver already provided",
    YESBINDCHANGES = "Yes, bind with changes",
    NOBINDCHANGES = "No additional changes needed",
    IncludedExcludedOfficers = "Yes, file(s) attached"
}

export enum RenewalPolicyOptionsValue{
    RENEW = "Renew",
    DO_NOT_RENEW = "DNR",

    REQUOTE_WITH_CHANGES = "ReQuote",
    NO_REQUOTE_NEEDED = "NoReQuote",
}
export enum YesNo{
    YES = "Yes",
    NO = "No",
    ACCEPT = "Accept",
    DECLINE = "Decline"
}

export enum YesNoValue{
    ACCEPTED = "Accepted",
    DECLINED = "Declined"
}
export enum RenewalGroups {
    DO_NOT_RENEW = "donotrenew",
    MEDIA_TYPE = "mediatype",
    COMPANY_NAME_UPDATE = "company_name_update"
}

export enum DoNotRenewalPolicyReasons {
    PRICE = "Price",
    BETTER_COVERAGE_OPTIONS = "Better coverage options",
    POLICY_NO_LONGER_NEEDED = "Policy no longer needed",
    BROKER_OF_RECORD = "Broker of record",
    NO_LONGER_IN_BUSINESS = "No longer in business",
    LOST_ACCOUNT = "Lost account",
    NO_RESPONSE_FROM_INSURED = "No response from insured",
    OTHER = "Other"
}

export enum DiceExposuresMediaTypes {
    COMMERCIAL = "commercial",
    DOCUMENTARY = "documentary",
    EDUCATIONAL = "educational",
    INDUSTRIAL = "industrial",
    PODCAST = "podcast",
    WEBISODES = "webisodes",
    OTHER = "other"
}

export enum DiceRenewalBindStatus {
    SUBMITTED = "submitted",
    DECLINED = "declined",
    ERROR = "error"
}

export enum RenewalBindPolicyStatus {
    Bound = "Bound",
    OfflineProcessBindProcessError = "Offline_Processing_Bind_Process_Error", // General Error
    OfflineProcessRateApiError = "Offline_Processing_BindRate_Api_Error", // General Error
    OfflineProcessPolicy = "Offline_Processing_Policy", // WC - Offline 
    OfflineProcessKO = "Offline_Processing_Kick_Off", // All Other polcies except Primary line
    OfflineProcessPLDNR = "Offline_Processing_Primary_Line_DNR", // Primary Line DNR
    OfflineProcessDNR = "Offline_Processing_DNR", // WC DNR
    DNRSuccess = "DNR_Success", //Any other policy DNR except Primary Line and WC
    DNRFail = "DNR_Fail"    //Any other policy DNR except Primary Line and WC
}

export enum ContactType {
    AUDIT = 'Audit',
    BILLING = 'Billing'
}

export enum CompanyLegalNameUpdateReason {
    SPELLING_CORRECTION = "Spelling Correction",
    BUSINESS_CHANGED_NAME = "Business changed their name",
    BUSINESS_NEW_OWNERSHIP = "Business under new ownership",
    OTHER = "Other"
}

export enum AccountAddressType{
    ORIGINAL = "original",
    CURRENT = "current"
}

export enum RenewalStatusValue{
    RENEWAL_PERIOD_OPEN = "RenewalPeriodOpen",
    RENEWAL_IN_PROGRESS = "RenewalInProgress",
    OFFLINE_PROCESSING = "OfflineProcessing",
    RENEWAL_BOUND = "RenewalBound",
    RENEWAL_ISSUED = "RenewalIssued",
    RENEWAL_DECLINED = "RenewalDeclined",
    RENEWAL_PERIOD_EXPIRED = "RenewalPeriodExpired",
    REFERRED_TO_UNDERWRITING = "ReferredToUW",
    NON_RENEWED = "Non-Renewed"
}

export enum PolicyProductName {
    Automobile = "Automobile",
	Umbrella = "Umbrella",
	Excess = "Excess",
	GeneralLiability = "Mono-line General Liability",
	InlandMarine = "Mono-line Inland Marine",
	Package = "Package",
	Property = "Mono-line Property",
	WorkersCompensation = "Workers Compensation",
	Crime = "Mono-line Crime"
}

export enum RenewalBindCoverages {
    Tria = "Tria",
    Cyber = "Cyber",
    Auto = "Auto",
    WorkersCompensation = "WorkersCompensation",
    AdditionalCoverage = "AdditionalCoverage"
}

export enum RenewalProductInstanceStatusGroup {
    OPEN = "Open",
    CLOSED = "Closed",
    ISSUED = "Issued",
    BOUND = "Bound"
}

export enum BillingStatus {
    Cancelled_NonPay = "Cancelled (Non Payment)",
    PendingCancellation = "Pending Cancellation",
    Active = "Active"
}

export enum RenewalNotices {
    ConditionalNotice = "Conditional Renewal",
    NonRenewalNotice = "Non-Renewal Notice"
}

export enum DocumentExtensionEnum{
    PDF = ".pdf",
    Word = ".doc", 
    WordZip = ".docx",
    WordMacro = ".docm",
    Excel = ".xls",
    ExcelZip = ".xlsx",
    ExcelMacro = ".xlsm",
    ExcelComma = ".csv"
}

export enum DocumentTypeEnum{
    PDF = "pdf",
    Word = "msword", 
    WordZip = "vnd.openxmlformats-officedocument.wordprocessingml.document",
    WordMacro = "vnd.ms-word.document.macroEnabled.12",
    Excel = "vnd.ms-excel",
    ExcelZip = "vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ExcelMacro = "vnd.ms-excel.sheet.macroEnabled.12",
    ExcelComma = "csv"
}